<template>
  <div class="header">
    <button
      @click="menuToggle()"
      :class="[
        {'open': menuOpen},
        'header__burger'
      ]"
      type="button">
      <span></span>
    </button>
    <div class="header__group">
      <BaseBtn
        v-if="build.reload"
        @btnClick="reloadPage()"
        text="Обновить личный кабинет"
        modifier="red"
        class="header__btn" />
      <template v-else>
        <div
          class="header__text">
          {{ userInfo.name }}
        </div>
        <router-link to="/account/profile" class="header__avatar">
          <BaseLazyImage v-if="getDealerAvatar" class="avatar" :src="getDealerAvatar" />
          <img v-else class="login-lk" src="@/assets/img/login-lk.svg" alt="" title=""/>
        </router-link>
      </template>
    </div>
    <Navigation
      v-if="menuOpen"
      :menuOpen="menuOpen"
      @menuToggle="menuToggle" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: 'Header',

  components: {
    Navigation: () => import('./Navigation'),
    BaseBtn: () => import('@/components/base/BaseBtn'),
    BaseLazyImage: () => import('@/components/base/BaseLazyImage'),
  },

  data: () => ({
    menuOpen: false,
  }),

  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      build: state => state.user.build,
    }),

    ...mapGetters('user', [
      'getDealerAvatar',
    ]),
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },

    menuToggle() {
      const menu = this.menuOpen;
      this.menuOpen = !menu;
      if (this.isMobile) {
        if (!menu) {
          document.body.classList.add('overflow');
        } else {
          document.body.classList.remove('overflow');
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

.login-lk {
  width: 100%;
  height: auto;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 5px 15px;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  background-color: #fff;
  z-index: 98;

  @media(max-width: $desktop) {
    box-shadow: 0px 4px 60px rgba(0, 0, 0, 0.1);
  }

  &__btn {
    padding: 0 15px;
    font-size: 14px;
    height: 26px;
    margin-top: 8px;
    margin-bottom: 9px;
  }

  &__avatar {
    line-height: 0;
    width: 43px;
    border-radius: 100%;
    border: 1px solid #000;
    overflow: hidden;
    flex-shrink: 0;

    @media(max-width: $desktop) {
      width: 35px;
    }
  }

  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  &__text {
    font-weight: bold;
    margin-right: 10px;

    @media(max-width: $desktop) {
      font-size: 12px;
      line-height: 15px;
    }
  }

  &__burger {
    height: 20px;
    width: 30px;
    background-color: transparent;
    border: 0;
    padding: 0;
    margin: 0;

    &.open {
      z-index: 25;

      span {
        background-color: transparent;

        &:after,
        &:before {
          top: 0;
          bottom: 0;
          margin: auto;
        }

        &:after {
          transform: rotate(45deg);
          background-color: #fff;
        }

        &:before {
          transform: rotate(-45deg);
          background-color: #fff;
        }
      }
    }

    span {
      display: block;
      border-radius: 2px;
      background-color: #495058;
      height: 1px;
      position: relative;
      transition: 0.3s;

      &:after,
      &:before {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background-color: #495058;
        position: absolute;
        left: 0;
        transition: 0.3s;
      }

      &:after {
        top: -10px;
      }

      &:before {
        bottom: -10px;
      }
    }
  }
}
</style>
